import { defineComponent as m, inject as s, computed as d, h as f } from "vue";
import { inputInjectionKey as i } from "./highrise1139.mjs";
import { len as p } from "./highrise1141.mjs";
import { resolveSlotWithTypedProps as c } from "./highrise1059.mjs";
const R = m({
  name: "InputWordCount",
  setup(v, {
    slots: o
  }) {
    const {
      mergedValueRef: t,
      maxlengthRef: u,
      mergedClsPrefixRef: a,
      countGraphemesRef: l
    } = s(i), n = d(() => {
      const {
        value: e
      } = t;
      return e === null || Array.isArray(e) ? 0 : (l.value || p)(e);
    });
    return () => {
      const {
        value: e
      } = u, {
        value: r
      } = t;
      return f("span", {
        class: `${a.value}-input-word-count`
      }, c(o.default, {
        value: r === null || Array.isArray(r) ? "" : r
      }, () => [e === void 0 ? n.value : `${n.value} / ${e}`]));
    };
  }
});
export {
  R as default
};
